import React, { useState, useEffect } from "react";
import {
  fetchBotSteps,
  fetchStepChats,
  getSessionsByBotAndUser,
} from "../../services/api";
import { DataState } from "./../../context/DataProvider";
import TextFormat from "../TextFormat"; // Assuming you have a TextFormat component
import Loader2 from "../custom/Loader2";
import { IoMdClose } from "react-icons/io";
const PreviousExecutionsModal = ({ botId, onClose }) => {
  const [sessions, setSessions] = useState([]);
  const [selectedSession, setSelectedSession] = useState(null);
  const [botSteps, setBotSteps] = useState([]);
  const [stepChats, setStepChats] = useState({});
  const [loading, setLoading] = useState(false);
  const { userGoogleId, userInfo } = DataState();

  useEffect(() => {
    if (botId) {
      setLoading(true);
      getSessionsByBotAndUser(botId, userGoogleId)
        .then((response) => {
          setSessions(response.sessions);
          setLoading(false);
        })
        .catch(() => setLoading(false));
    }
  }, [botId, userGoogleId]);

  const handleSessionClick = (sessionId) => {
    setLoading(true);
    fetchBotSteps(botId, userGoogleId)
      .then(async (response) => {
        if (response.error) {
          console.log("Error:", response.error);
          return;
        }
        setBotSteps(response.steps);
        setSelectedSession(sessionId);

        const chatsForSteps = {};
        for (let step of response.steps) {
          const stepChats = await fetchStepChats(
            botId,
            step.id,
            userGoogleId,
            sessionId
          );
          chatsForSteps[step.id] = stepChats.chats;
        }

        setStepChats(chatsForSteps);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  function formatDate(date) {
    const options = { day: "numeric", month: "short", year: "numeric" };
    return new Date(date).toLocaleDateString("en-GB", options);
  }

  return (
    <div
      className={`fixed inset-0 z-50 ${
        botId ? "block" : "hidden"
      } bg-black bg-opacity-50`}
    >
      <div className="relative p-8 bg-2 border border-zinc-700 text-zinc-100 w-full max-w-3xl mx-auto my-8 rounded-lg shadow-lg">
        <div className="flex justify-between items-center">
          <h2 className="text-xl font-bold">Previous Executions</h2>
          <button
            onClick={onClose}
            className="absolute top-5 right-5 bg-1 transition-all duration-200 rounded-lg p-1.5"
          >
            <IoMdClose />
          </button>
        </div>

        <div className="mt-4 max-h-[calc(65vh)] overflow-y-auto">
          {loading ? (
            <div className="text-center h-96 flex items-center justify-center">
              <Loader2 />
            </div>
          ) : sessions.length === 0 ? (
            <p className="text-center text-gray-500">No sessions found.</p>
          ) : (
            <ul className="space-y-2">
              {sessions.map((session, index) => (
                <li
                  key={session.id}
                  className={`p-4 cursor-pointer rounded-lg hover:bg-zinc-800 hover:bg-opacity-80 ${
                    selectedSession === session.id
                      ? "bg-zinc-800"
                      : "bg-zinc-800"
                  } `}
                  onClick={() => handleSessionClick(session.id)}
                >
                  <div className="flex items-center gap-1">
                    <div className="bg-zinc-900 h-7 w-7 rounded-full mr-2 flex items-center justify-center">
                      {index + 1}
                    </div>
                    {formatDate(session.timestamp)}
                  </div>

                  {selectedSession === session.id && (
                    <ul className="space-y-4 mt-3">
                      {botSteps.map((step) => (
                        <li
                          key={step.id}
                          className=" text-sm bg-zinc-900 p-4 rounded-md"
                        >
                          <strong>Step {step.step_index + 1}:</strong>{" "}
                          {step.step_title}
                          <div className="mt-2">
                            {[...(stepChats[step.id] || [])].map((chat, i) => {
                              const { role, content } = chat;
                              const textContent = content;
                              if (
                                !textContent ||
                                !textContent.trim() ||
                                role === "tool"
                              ) {
                                return null;
                              }
                              return role === "bot" ? (
                                <pre
                                  key={i}
                                  className="whitespace-pre-wrap break-words bg-zinc-800 p-4 rounded-md overflow-x-auto"
                                >
                                  <TextFormat response={textContent} />
                                </pre>
                              ) : (
                                <div key={i} className="flex gap-1 items-start">
                                  <div className="min-h-10 min-w-10 pt-3">
                                    {role === "user" ? (
                                      <img
                                        src={
                                          userInfo
                                            ? userInfo.picture
                                            : "../assets/nirmal.png"
                                        }
                                        className="rounded-full h-7 w-7 object-cover"
                                      />
                                    ) : (
                                      <img
                                        src="../assets/logo.png"
                                        className="rounded-full h-7 w-7 object-contain bg-black p-1"
                                      />
                                    )}
                                  </div>
                                  <p className="text-sm">
                                    <TextFormat response={textContent} />
                                  </p>
                                </div>
                              );
                            })}
                          </div>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default PreviousExecutionsModal;
